export enum LocalStorageKeys {
    AuthToken = "token",
    SessionToken = "sessionToken",
    Profile = "profile",
    Restaurant = "restaurant",
    AccountRefId = "accountRefId",
    IsRegisterRestuarant = "isRegisterRestuarant",
    DeviceToken = "deviceToken",
    IsRestuarantCheckListLoaded = "isRestuarantCheckListLoaded",
    BusinessRefId = "businessRefId",
    NativeAppsInfo = "nativeAppsInfo",
    KdsSettingsUpdated = "kdsSettingsUpdated",
    BrandColor = "brandColor",
    OverViewSelectedDateFilter = "overViewSelectedDateFilter",
}
